// Connection-recovery actions (G33). The same URL-rewrite recovery dance was
// hand-copied across ConnectingSplash, Topbar and ErrorBoundary; this is the
// single seam. Deliberately a plain, dependency-free module — NO React, NO
// store, NO i18n — so ErrorBoundary (a class component that intentionally
// avoids the store, to stay renderable even if the store threw) can import it.
// Each function wraps exactly today's logic and is guarded like the originals.

/** Full reload — re-runs boot-time TB discovery. */
export function reload(): void {
  try { window.location.reload(); } catch { /* sandboxed / detached */ }
}

/** Fall back to the in-browser mock simulator (set ?mock=1, drop ?live). */
export function switchToMock(): void {
  try {
    const u = new URL(window.location.href);
    u.searchParams.set("mock", "1");
    u.searchParams.delete("live");
    window.location.href = u.toString();
  } catch { /* sandboxed / detached */ }
}

/** Inverse of switchToMock: retry the live TB connection (drop ?mock, set ?live=1). */
export function retryLive(): void {
  try {
    const u = new URL(window.location.href);
    u.searchParams.delete("mock");
    u.searchParams.set("live", "1");
    window.location.href = u.toString();
  } catch { /* sandboxed / detached */ }
}
